module.exports = __webpack_public_path__ + "img/pineapple.c7040ee9.svg";